import React from "react";
import { InventoryIcon as PackageIcon } from "@sscs/ui/icons";
import { ActionMenu, AllowedTo } from "Components";
import { PERMISSION } from "Constants";
import { useDialog } from "Hooks";
import { ActionItem, ProjectSummary } from "Types";
import CreatePackage from "../../../components/CreatePackage/CreatePackage";
import CreateProject from "../../../components/CreateProject/CreateProject";
import DeleteProjectDialog from "../../../components/DeleteProjectDialog/DeleteProjectDialog";

type ProjectLabelProps = {
  id: string;
  project: ProjectSummary;
  maxPackagesLimit: number;
};

const ProjectLabel = ({
  id,
  project,
  maxPackagesLimit,
}: ProjectLabelProps): React.JSX.Element => {
  const deleteDialog = useDialog();
  const editDialog = useDialog();
  const createPackageDialog = useDialog();

  const maximumPackagesLimitReached =
    project.packages.length >= maxPackagesLimit;

  const actions: ActionItem[] = [
    {
      id: "create-package",
      type: "CUSTOM",
      text: "Create package",
      onClick: createPackageDialog.open,
      itemIcon: <PackageIcon />,
      isDisabled: maximumPackagesLimitReached,
      permissions: [PERMISSION.CREATE_PACKAGE],
    },
    {
      id: "edit-project",
      type: "EDIT",
      text: "Edit project",
      onClick: editDialog.open,
      permissions: [PERMISSION.CREATE_PROJECT],
    },
    {
      id: "delete-project",
      type: "DELETE",
      text: "Delete project",
      onClick: deleteDialog.open,
      permissions: [PERMISSION.DELETE_PROJECT],
    },
  ];

  return (
    <>
      <AllowedTo
        permissions={[
          PERMISSION.CREATE_PROJECT,
          PERMISSION.DELETE_PROJECT,
          PERMISSION.CREATE_PACKAGE,
        ]}
      >
        <ActionMenu id={id} items={actions} size="small" />
      </AllowedTo>
      <CreateProject
        isOpen={editDialog.isOpen}
        onClose={editDialog.close}
        project={project}
      />
      <DeleteProjectDialog
        isOpen={deleteDialog.isOpen}
        onClose={deleteDialog.close}
        project={project}
      />
      <CreatePackage
        isOpen={createPackageDialog.isOpen}
        onClose={createPackageDialog.close}
        projectId={project.project_id}
        projectName={project.name}
      />
    </>
  );
};

export default ProjectLabel;
